import Wrapper from "../../../layout/Wrapper";
import ContractNearExpiredReportComponent from "../../../screens/reports/contractNearExpired";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Contract Nearly Expired Report",
	description: "",
};

export default function ContractNearExpiredReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ContractNearExpiredReportComponent />
		</Wrapper>
	);
}